import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { ArticleCard } from '../components/ArticleCard';
import { Skeleton } from '../components/ui/skeleton';
import { useAuth } from '../contexts/AuthContext';
import { History } from 'lucide-react';
import { API, authFetch } from '../lib/api';

export const ReadingHistoryPage = () => {
  const { user, loading: authLoading, login } = useAuth();
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && !user) {
      login();
      return;
    }
    if (user) fetchHistory();
  }, [authLoading, user]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await authFetch(`${API}/reading-history?limit=50`);
      if (response.ok) {
        setArticles(await response.json());
      }
    } catch (error) {
      console.error('Failed to fetch reading history:', error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background" data-testid="reading-history-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-8">
          <History className="w-6 h-6 text-accent" />
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Fraunces, serif' }}>
            Reading History
          </h1>
        </div>

        <div className="divide-y divide-border">
          {loading ? (
            Array(4).fill(0).map((_, i) => (
              <div key={i} className="py-6">
                <Skeleton className="h-4 w-32 mb-3" />
                <Skeleton className="h-6 w-full mb-2" />
                <Skeleton className="h-4 w-48" />
              </div>
            ))
          ) : articles.length > 0 ? (
            articles.map(article => (
              <ArticleCard key={article.article_id} article={article} />
            ))
          ) : (
            <div className="py-16 text-center">
              <History className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No reading history yet. Start reading articles!</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ReadingHistoryPage;
